// progressPanel.component.ts
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CampaignService } from "src/app/_services/campaign.service";
import { ICampaign, ICampaignStage } from "src/app/model/campaign";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { LocalStorageService } from "src/app/_services/local-storage.service";
import { campaignTargetListingPath, getProjectNumberFromUrl } from "../campaign-scope.util";
declare const clevertap;

@Component({
    selector: "app-progress-panel",
    templateUrl: "./progress-panel.component.html",
    styleUrls: ["./progress-panel.component.scss"],
    standalone: false
})
export class ProgressPanelComponent implements OnInit {
  projectNumber = getProjectNumberFromUrl();

  @Input() campaign_details: ICampaign;
  @Input() isInEditMode: { stageId; editMode } = {
    stageId: null,
    editMode: false,
  };

  @Output() selected: EventEmitter<ICampaignStage> =
    new EventEmitter<ICampaignStage>();
  @Output() addStep: EventEmitter<number> = new EventEmitter<number>();
  @Output() changeEditMode: EventEmitter<{}> = new EventEmitter<{
    stageId: null;
    isEditing: false;
  }>();

  @Input() stages: ICampaignStage[] = [];
  @Input() stage: ICampaignStage;
  @Input() currentActiveCampaignCount: number = 0;
  @ViewChild("confirmTemplateModal")
  confirmTemplateModal: TemplateRef<NgbModalRef>;
  get hasStages() {
    return this.stages && this.stages.length;
  }

  @Input() canSwitch: boolean = false;
  @Input() readOnly = false;

  activeStage: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private campaignService: CampaignService,
    private modalservice: NgbModal,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    if (this.hasStages) {
      this.selectStage(this.stages[0].campaign_stage_id);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.stages) {
      // Handle the changes to the stages input here
      this.stages = this.stages.map((stage, index) => {
        const temp = changes?.stage?.currentValue;
        if (
          stage &&
          temp &&
          temp.campaign_stage_id &&
          stage.campaign_stage_id === temp.campaign_stage_id
        ) {
          return changes.stage.currentValue;
        } else {
          // this.activeStage = stage?.campaign_stage_id;
          return stage;
        }
      });
    }
    //check for changes in stage and update activeStage
    if (changes.stage) {
      //if campaign_stage_id is null

      if (changes.stage.currentValue?.campaign_stage_id == null) {
        this.selectStage(changes.stage.currentValue?.campaign_stage_id);
        this.activeStage = changes.stage.currentValue?.campaign_stage_id;
      } else {
        this.activeStage = changes.stage.currentValue?.campaign_stage_id;
      }
      if (
        this.stages &&
        this.stages.length &&
        changes.stage.currentValue?.campaign_stage_id ===
          this.stages[this.stages.length - 1].campaign_stage_id
      ) {
        const element = document.getElementById("follow-up-btn");
        if (element) element.scrollIntoView();
      }
    }
  }
  goToTargetListing() {
    this.router.navigate(campaignTargetListingPath(this.campaign_details["campaign_id"], this.projectNumber));
  }

  selectStage(stageId: number) {
    if (this.isInEditMode && this.isInEditMode.editMode) {
      return;
    } else {
      // this.changeEditMode.emit({stageId: null, isEditing: true});
      this.activeStage = stageId;
      // this.isStageActive(stageId);
      this.selected.emit(
        this.stages.find((stage) => stage.campaign_stage_id === stageId)
      );
    }
  }

  isStageActive(stageId: number) {
    return stageId === this.activeStage;
  }

  readonly MAX_STAGES = 5;

  get isMaxStagesReached(): boolean {
    return this.stages && this.stages.length >= this.MAX_STAGES;
  }

  addNewStage() {
    if (this.isMaxStagesReached) return;
    //send event to parent component to update availableStages[]
    if (this.stages && this.stages.length)
      this.addStep.emit(this.stages.length);
    else this.addStep.emit(0);
  }

  openConfirmationModal() {
    const modalRef = this.modalservice.open(this.confirmTemplateModal, {
      size: "confirmation-modal-size",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
  }
  onStartCampaignClick() {
    const payloadObject = {
      campaign_id: this.campaign_details["campaign_id"],
      status: this.currentActiveCampaignCount > 0 ? 2 : 1, // if user has reached the maximum limit of active campaigns allowed, campaign will be paused instead of activated
      timezone: this.campaign_details.timezone,
      schedule: this.campaign_details.schedule,
      updatedon: new Date().toISOString(),
      email_pref: this.campaign_details.email_pref,
      useremailintegrationid: this.campaign_details.useremailintegrationid,
    };
    this.campaignService.updateCampaign(payloadObject).subscribe(
      (res: any) => {
        this.closeModal();
        this.router.navigate(campaignTargetListingPath(this.campaign_details["campaign_id"], this.projectNumber)); //TODO: navigate to here after setting isactive = 1 to start campaign.
        /**
         * clevertap start campiagn event
         */
        const emailCampignParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Campaign Created": "Yes",
          "Candidate Added": "No",
          "Steps": JSON.stringify(this.stages)
        }
        clevertap.event.push("Campaign Created", emailCampignParams);
      },
      (error) => {
        // this.errorMessage = 'Error updating stage';
        //   setTimeout(() => this.errorMessage = '', 3000);
        console.error("Error updating stage:", error);
      }
    );
  }
  /**
   * function to delete campaign stage (only in draft stage i.e, campaign_stage_status = 3)
   * @param campaignStageId campaign stage id to be deleted
   */
  deleteCampaignStage(campaignStageId: number, index: number) {
    this.campaignService
      .updateStage(this.campaign_details.id, campaignStageId, {
        is_active: false,
      })
      .subscribe((res) => {
        this.addStep.emit(-2);
        this.selectStage(this.stages[index-1].campaign_stage_id);
      });
  }

  closeModal() {
    this.modalservice.dismissAll();
  }
}
